import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import PanelView from '@/components/globals/PanelView'
import ErrorPanel from '@/components/globals/ErrorPanel'

loadFonts()
createApp(App)
  .component('panel-view', PanelView)
  .component('error-panel', ErrorPanel)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')
